import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeIn } from "@/components/Reveal";
import { VENDOR_FORM_URL } from "@/constants/links";

const advantages = [
  "A trusted stage for your brand, built for cross-border reach",
  "A direct line to shoppers across Africa",
  "Founding-vendor consideration when the marketplace opens",
];

export default function BecomeVendor() {
  return (
    <section data-testid="become-vendor-page" className="relative overflow-hidden pb-24 pt-32 sm:pt-40 lg:pt-48">
      <div className="pointer-events-none absolute -top-24 right-[-8%] h-[26rem] w-[26rem] rounded-full bg-[#1E3A8A]/10 blur-[110px]" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-16 px-4 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-16">
        <div>
          <p className="eyebrow" data-testid="vendor-eyebrow">Early Access · Vendors</p>
          <h1 className="mt-8 font-sans text-4xl font-bold leading-[1.08] tracking-tight text-[#0F172A] sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.15}>Your brand,</MaskedLine>
            <MaskedLine delay={0.3} className="text-gold-gradient">on a bigger stage.</MaskedLine>
          </h1>
          <FadeIn delay={0.55}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-[#64748B] sm:text-lg">
              Aflimart Digital Market is curating its founding circle of vendors — brands, manufacturers, merchants and
              artisans, in Africa and beyond. Register your interest and be considered before the doors open.
            </p>
            <ul className="mt-10 space-y-4">
              {advantages.map((p, i) => (
                <FadeIn key={p} delay={0.1 * i}>
                  <li data-testid={`vendor-advantage-${i + 1}`} className="flex items-start gap-3 text-sm text-[#475569] sm:text-base">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#1E3A8A]/50">
                      <Check size={11} className="text-[#1E3A8A]" />
                    </span>
                    {p}
                  </li>
                </FadeIn>
              ))}
            </ul>
          </FadeIn>
        </div>

        <FadeIn delay={0.35}>
          <div
            data-testid="vendor-interest-form"
            className="card-dark p-8 sm:p-10 hover:transform-none"
          >
            <h2 className="font-sans text-2xl text-[#0F172A]">Register your interest</h2>
            <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">
              Vendor onboarding is handled through our official form — tell us about your business there.
            </p>
            <div className="mt-10">
              <a
                href={VENDOR_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="vendor-submit-button"
                className="btn-gold w-full"
              >
                Start Vendor Onboarding <ArrowUpRight size={16} />
              </a>
              <p data-testid="vendor-form-note" className="mt-6 text-center font-sans text-[10px] leading-relaxed tracking-[0.15em] text-[#CBD5E1]">
                OFFICIAL AFLIMART FORM — OPENS IN A NEW TAB. SUBMISSIONS ARE RECORDED IN OUR GOOGLE TRACKER.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.45} className="lg:col-start-2">
          <Link to="/restaurant-signup" data-testid="vendor-restaurant-link" className="card-dark group flex items-center justify-between gap-4 p-6 sm:p-8 hover:-translate-y-1">
            <div>
              <p className="font-sans text-[10px] tracking-[0.25em] text-[#1E3A8A]/70">FOODS CATEGORY</p>
              <p className="mt-2 font-sans text-lg text-[#0F172A] sm:text-xl">Run a restaurant or food business?</p>
              <p className="mt-1 text-sm leading-relaxed text-[#94A3B8]">
                Use the dedicated restaurant onboarding — menu, hours and delivery details included.
              </p>
            </div>
            <ArrowUpRight size={20} className="shrink-0 text-[#1E3A8A] transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
          </Link>
        </FadeIn>
      </div>
    </section>
  );
}
